import React from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../../Services/translation';
import ReorderButton from '../ReorderButton';
import ApproveOrderButton from '../ApproveOrderButton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../primitives/Table';
import OrderStatus from '../primitives/OrderStatus';

const OrderHistoryList = ({ onShowDetail, isReseller }) => {
  const orders = useSelector((state) => state.myPage.orders.list);

  return (
    <div className="order-history__list">
      {orders?.length && (
        <>
        <div className='space-y-2 lg:hidden'>
          {orders.map((order) => (
            <div key={order.externalOrderID} className='border border-border-primary rounded-radius px-4 py-5 space-y-3 cursor-pointer' onClick={() => onShowDetail(order)}>
              <div className='flex items-center gap-1 justify-between flex-wrap'>
                <div className='font-bold text-sm'>{translate('orderlist.column.orderdate')}</div>
                <div>{new Date(order.orderDate).toLocaleDateString(undefined, {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    })}</div>
              </div>
              <div className='flex items-center gap-1 justify-between flex-wrap'>
                <div className='font-bold text-sm'>{translate('orderlist.column.ordernumber')}</div>
                <div>{isReseller ? order.externalId : order.externalOrderID}</div>
              </div>
              <div className='flex flex-col gap-1'>
                <div className='font-bold text-sm'>{translate('orderlist.column.content')}</div>
                <div className='text-accent'>{isReseller ? (
                      <>
                        {`${order.customer?.firstName} ${order.customer?.lastName}`.trim()}
                      </>
                    ) : (
                      <>
                        {order.orderRows?.[0]?.brand}
                        <span>{order.orderRows?.[0]?.name}</span>&nbsp;
                        {order.orderRows?.length > 1 &&
                          translate(
                            order.orderRows?.length > 2
                              ? 'orderlist.items'
                              : 'orderlist.item'
                          ).replace('{0}', order.orderRows?.length - 1)}
                      </>
                    )}
                </div>
              </div>
              <div className='flex items-center gap-1 justify-between flex-wrap'>
                <div className='font-bold text-sm'>{translate('orderlist.column.status')}</div>
                <div><OrderStatus status={order.status} color={order.statusColor} /></div>
              </div>
              <div className='flex items-center gap-1 justify-between flex-wrap'>
                <div className='font-bold text-sm'>{translate('orderlist.column.ordersum')}</div>
                <div className='font-bold text-accent'>{isReseller ? order.grandTotal : order.orderGrandTotal}</div>
              </div>
            </div>
          ))}
        </div>

        <Table className='hidden lg:table'>
          <TableHeader>
            <TableRow>
              <TableHead className="px-5 border border-transparent">
                {translate('orderlist.column.orderdate')}
              </TableHead>
              <TableHead className="px-5 border border-transparent">
                {translate('orderlist.column.ordernumber')}
              </TableHead>
              <TableHead className="px-5 border border-transparent">
                {translate('orderlist.column.content')}
              </TableHead>
              <TableHead className="px-5 border border-transparent">
                {' '}
                {translate('orderlist.column.status')}
              </TableHead>
              <TableHead className="text-right px-5 border border-transparent">
                {translate('orderlist.column.ordersum')}
              </TableHead>{' '}
            </TableRow>
          </TableHeader>

          <TableBody>
            {orders.map((order) => (
              <TableRow
                key={order.externalOrderID}
                onClick={() => onShowDetail(order)}
                className="group/table cursor-pointer [&>td>div]:border-t [&>td>div]:border-b [&>td>div]:border-border-primary [&>td>div]:py-5 [&:first-of-type>td>div]:mt-4 [&:not(:last-of-type)>td>div]:mb-2 [&>td>div]:px-6 [&>td]:p-0 [&>td:first-of-type>div]:border-l [&>td:first-of-type>div]:rounded-l-2xl [&>td:last-of-type>div]:border-r [&>td:last-of-type>div]:rounded-r-2xl"
              >
                <TableCell className="font-medium max-w-[120px]">
                  <div className="group-hover/table:bg-background-tertiary">
                    {new Date(order.orderDate).toLocaleDateString(undefined, {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    })}
                  </div>
                </TableCell>
                <TableCell className="max-w-[120px]">
                  <div className="group-hover/table:bg-background-tertiary">
                    {isReseller ? order.externalId : order.externalOrderID}
                  </div>
                </TableCell>
                <TableCell>
                  <div className="group-hover/table:bg-background-tertiary text-ellipsis overflow-hidden whitespace-nowrap">
                    {isReseller ? (
                      <>
                        {`${order.customer?.firstName} ${order.customer?.lastName}`.trim()}
                      </>
                    ) : (
                      <>
                        {order.orderRows?.[0]?.brand}
                        <b>{order.orderRows?.[0]?.name}</b>&nbsp;
                        {order.orderRows?.length > 1 &&
                          translate(
                            order.orderRows?.length > 2
                              ? 'orderlist.items'
                              : 'orderlist.item'
                          ).replace('{0}', order.orderRows?.length - 1)}
                      </>
                    )}
                  </div>
                </TableCell>
                <TableCell className="w-[120px]">
                  <div className="group-hover/table:bg-background-tertiary">
                    <OrderStatus
                      status={order.status}
                      color={order.statusColor}
                    />
                  </div>
                </TableCell>
                <TableCell className="text-right max-w-[120px]">
                  <div className="group-hover/table:bg-background-tertiary font-bold text-accent">
                    {isReseller ? order.grandTotal : order.orderGrandTotal}
                  </div>
                </TableCell>
                <TableCell className="text-right max-w-[120px] w-fit">
                  <div className="group-hover/table:bg-background-tertiary size-[62px] relative">
                    <div
                      // onClick={() => onShowDetail(order)}
                      className="order-detail__product-link"
                      // type="button"
                    >
                      <span className="icon icon-outlined">chevron_right</span>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        </>
      )}

      {orders?.length <= 0 && <div>{translate('orderlist.noorderfound')}</div>}
    </div>
  );
};

export default OrderHistoryList;
